/**
 * Vuex store untuk state UI lokal saja.
 *
 * Server state (branch, courier, payment, agen, dll) sudah pindah ke
 * @tanstack/vue-query — lihat src/composables/master/useMaster.js.
 *
 * State yang TETAP di sini:
 *   - selectedItem, selectedColumns, exclude_branch, excludeAagen, set_agen
 *     → murni UI state (filter/seleksi user yang persist antar halaman)
 *   - dataInvoice → temporary cross-page data
 */
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedItem: [],
    selectedColumns: null,
    exclude_branch: [],
    excludeAagen: [],
    set_agen: null,
    dataInvoice: null,
  },
  mutations: {
    setExcludeAgen(state, payload) {
      state.excludeAagen = payload;
    },
    setNameAgent(state, payload) {
      state.set_agen = payload;
    },
    putSelectedItem(state, payload) {
      state.selectedItem = payload;
    },
    putSelectedColumns(state, payload) {
      state.selectedColumns = payload;
    },
    putExcludeBranch(state, payload) {
      state.exclude_branch = payload;
    },
    setDataInvoice(state, payload) {
      state.dataInvoice = payload;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    /* Persist hanya state UI yang harus survive reload.
       Server state TIDAK perlu di-persist karena akan refetch via query. */
    createPersistedState({
      paths: [
        "selectedItem",
        "selectedColumns",
        "exclude_branch",
        "excludeAagen",
        "set_agen",
      ],
    }),
  ],
});
